const clearFilterButtonManagementEquip = {
  Typography: 'Borrar todos'
};

export default clearFilterButtonManagementEquip;
